// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from "../src/components/Sidebar";
import MaterialCalculator from './components/MaterialCalculator/MaterialCalculator';
import AddHeading from './components/MaterialCalculator/AddHeading';
import AddMaterial from './components/MaterialCalculator/AddMaterial';
import AddFormula from './components/MaterialCalculator/AddFormula';
import EditFormula from './components/MaterialCalculator/FromulaEditor';
import './App.css'; 
import AddHeading2 from './components/MaterialCalculator/AddHeading2';
import QuotationBuilder from './components/MaterialCalculator/QuotationBuilder';
import HowToUse from './HowToUse';

const App = () => {
  return (
    <Router>
      <div className="app-layout">
        <Sidebar />
        <div className="main-content-area">
          <Routes>
          <Route path="/" element={<HowToUse />} />
            <Route path="/material-calculator" element={<MaterialCalculator />} />
            <Route path="/add-heading" element={<AddHeading />} />
            <Route path="/add-heading-2" element={<AddHeading2 />} />
            <Route path="/add-material" element={<AddMaterial />} />
            <Route path="/add-formula" element={<AddFormula />} />
            <Route path="/edit-formula" element={<EditFormula />} />
            <Route path="/quotation-builder" element={<QuotationBuilder />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
